import type AvailableActionsEnum from '../enums/AvalableActionsEnum'
import { JsonObject, JsonProperty } from 'json2typescript'
import AvalableActionsEnumArrayConverter from '@/converters/AvailableActionsEnumArrayConverter'
import DateConverter from '@/converters/DateConverter'
import PolicyStatusEnumConverter from '@/converters/PolicyStatusEnumConverter'
import ProductEnumConverter from '@/converters/ProductEnumConverter'
import PaymentTypeEnumConverter from '../../converters/PaymentTypeEnumConverter'
import { PaymentTypeEnum } from '../enums/DLDCommonValuesEnum'
import PolicyStatusEnum from '../enums/PolicyStatusEnum'
import ProductEnum from '../enums/ProductEnum'
import RenewalStatusEnum from '../enums/RenewalStatusEnum'
import DirectDebit from '../values/DirectDebit'
import GoCardlessDetails from '../values/GoCardlessDetails'
import PaymentSchedule from '../values/PaymentSchedule'
import ActionMessage from './ActionMessage'
import Model from './Model'
import Scheme from './Scheme'
import VAP from './VAP'

@JsonObject('Policy')
export default class Policy extends Model {
  @JsonProperty('policyNumber', String)
  policyNumber: string = ''

  @JsonProperty('product', ProductEnumConverter)
  product: ProductEnum = ProductEnum.modernCar

  @JsonProperty('policyStatus', PolicyStatusEnumConverter)
  policyStatus: PolicyStatusEnum = PolicyStatusEnum.live

  @JsonProperty('renewalStatus', PolicyStatusEnumConverter)
  renewalStatus: RenewalStatusEnum = RenewalStatusEnum.notSet

  @JsonProperty('effectiveDate', DateConverter)
  effectiveDate: Date = new Date()

  @JsonProperty('subscriptionEffectiveDate', DateConverter, true)
  subscriptionEffectiveDate: Date | null = null

  @JsonProperty('renewalDate', DateConverter)
  renewalDate: Date = new Date()

  @JsonProperty('annualRenewalDate', DateConverter)
  annualRenewalDate: Date = new Date()

  @JsonProperty('renewalQuoteReference', String)
  renewalQuoteReference: string | null = null

  @JsonProperty('willAutoRenew', Boolean)
  willAutoRenew: boolean = false

  @JsonProperty('vaps', [VAP])
  vaps: VAP[] = []

  @JsonProperty('isRefundedPendingChange', Boolean)
  isRefundedPendingChange: boolean = false

  @JsonProperty('paymentType', PaymentTypeEnumConverter)
  paymentType: PaymentTypeEnum = PaymentTypeEnum.Cash

  @JsonProperty('isPendingAmendment', Boolean)
  isPendingAmendment: boolean = false

  @JsonProperty('pendingRefundAmount', Number)
  pendingRefundAmount: number = 0

  @JsonProperty('scheme', Scheme)
  scheme: Scheme = new Scheme()

  @JsonProperty('availableActions', AvalableActionsEnumArrayConverter)
  availableActions: AvailableActionsEnum[] = []

  @JsonProperty('actionMessages', [ActionMessage])
  actionMessages: ActionMessage[] = []

  @JsonProperty('directDebitDetails', DirectDebit)
  directDebitDetails: DirectDebit | null = null

  @JsonProperty('paymentSchedule', PaymentSchedule)
  paymentSchedule: PaymentSchedule | null = null

  @JsonProperty('goCardlessDetails', GoCardlessDetails)
  goCardlessDetails: GoCardlessDetails | null = null

  @JsonProperty('isEligibleFor3YPF', Boolean)
  isEligibleFor3YPF: boolean = false

  @JsonProperty('subscriptionCalculatedTotalPayable', Number)
  subscriptionCalculatedTotalPayable: number = 0
}
